var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 166.667C28.75 166.667 24.8277 165.036 21.5666 161.775C18.3055 158.514 16.6722 154.589 16.6666 150V50C16.6666 45.4167 18.3 41.4945 21.5666 38.2334C24.8333 34.9723 28.7555 33.3389 33.3333 33.3334H166.667C171.25 33.3334 175.175 34.9667 178.442 38.2334C181.708 41.5 183.339 45.4223 183.333 50V150C183.333 154.583 181.703 158.508 178.442 161.775C175.181 165.042 171.256 166.672 166.667 166.667H33.3333ZM100 108.333L166.667 66.6667V50L100 91.6667L33.3333 50V66.6667L100 108.333Z",
    fill: "#00D0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.59230ff58671e299307c6e98ca4e59f2.svg";
export { ForwardRef as ReactComponent };